import React from 'react';
import { Link } from 'react-router-dom';
import { getArchiveInfo, getTagStats } from '../../utils/date';
import './Archive.css';

const Archive = ({ posts }) => {
  const archives = getArchiveInfo(posts);
  const tagStats = getTagStats(posts);

  return (
    <aside className="archive">
      <h3 className="archive-title">文章归档</h3>
      
      {/* 按日期归档 */}
      <div className="archive-section">
        <h4 className="archive-section-title">按日期</h4>
        <ul className="archive-list">
          {archives.map((archive) => (
            <li key={archive.key} className="archive-item">
              <Link 
                to={`/archive?date=${archive.key}`}
                className="archive-link"
              >
                <span>
                  {archive.year}年{archive.month}月
                </span>
                <span className="archive-count">
                  {archive.count}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* 标签云 */}
      <div className="archive-section">
        <h4 className="archive-section-title">标签云</h4>
        <div className="tag-cloud">
          {tagStats.map((tag) => (
            <Link
              key={tag.name}
              to={`/archive?tag=${tag.name}`}
              className="tag-cloud-item"
              style={{
                fontSize: `${Math.min(0.875 + tag.count * 0.05, 1.125)}rem`,
                opacity: Math.min(0.6 + tag.count * 0.1, 1)
              }}
            >
              {tag.name} ({tag.count})
            </Link>
          ))}
        </div>
      </div>

      {/* 统计信息 */}
      <div className="archive-section">
        <h4 className="archive-section-title">统计信息</h4>
        <div className="archive-stats">
          <div className="archive-stat-item">
            <span className="archive-stat-label">文章总数</span>
            <span className="archive-stat-value">{posts.length}</span>
          </div>
          <div className="archive-stat-item">
            <span className="archive-stat-label">标签总数</span>
            <span className="archive-stat-value">{tagStats.length}</span>
          </div>
          <div className="archive-stat-item">
            <span className="archive-stat-label">归档月份</span>
            <span className="archive-stat-value">{archives.length}</span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Archive;